// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MX3GJ","logo":"styles_logo__qW0l-"};